import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../session/session.service';
import { UserType } from 'sp-client';

export const superAdminGuard: CanActivateFn = (_route, _state) => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  const currentUser = sessionService.user();
  const isSuperAdmin = currentUser?.user_type_id === UserType.SuperAdmin;

  if (!isSuperAdmin) {
    router.navigate(['/']); // Redirect to home/dashboard if not super admin
    return false;
  }

  return true;
}; 